var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{staticClass:"welcomeImg",style:({'height': _vm.height}),attrs:{"src":_vm.welcomeImg}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }